/**
 * @generated SignedSource<<c21b88d1056554f21f12a4628f939389>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFooter_itemSearch$data = {
  readonly totalResults: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"sbSharedAppliedFiltersHelpers_itemSearch">;
  readonly " $fragmentType": "SbSharedRefineMenuFooter_itemSearch";
};
export type SbSharedRefineMenuFooter_itemSearch$key = {
  readonly " $data"?: SbSharedRefineMenuFooter_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFooter_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFooter_itemSearch",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "sbSharedAppliedFiltersHelpers_itemSearch",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clearAppliedFiltersLinkReference",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalResults",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "296d14abd234f97b3661243a5d127720";

export default node;
